import React, {Component } from 'react';
import twitter from './img/twitter-white.png';
import facebook from './img/facebook-white.png';

class Footer extends Component {
  render() {
    return (
        <footer>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <ul className="list-inline social-buttons">
                  <li><a href="https://twitter.com/playdash"><img src={twitter} alt="twitter" width="25" /></a>
                  </li>
                  <li><a href="https://www.facebook.com/playdash"><img src={facebook} alt="facebook" height="25" /></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </footer>
    );
  }

}

export default Footer;


// WEBPACK FOOTER //
// ./src/Footer.js